import { useState } from "react";
import styled from "styled-components";

import { fieldLabel } from "../../styles";
import { SelectColorModal } from "../CustomColorSection/SelectColorModal";
import InputColor from "../PreDefinedColorSection/components/InputColor";

/* Two fields side by side (one under the other on a phone): a font and its color, or two colors */
export const FieldPair = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Field = styled.div<{ $locked?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  font-family: Inter, sans-serif;

  .role {
    ${fieldLabel}
  }

  /* as tall as a font's field, and as light */
  [role="button"] {
    width: 100%;
    height: 52px;
    background: var(--color-neutral-base);
    border: 2px solid transparent;
    border-radius: 12px;
    opacity: ${props => props.$locked && "0.4"};
    filter: ${props => props.$locked && "grayscale(1)"};
  }
`;

type Props = {
  label: string;
  color: string;
  onPick: (color: string) => void;
  /** PLUS only: the color is shown but asks to subscribe (`onLocked`) instead of opening the picker. */
  locked?: boolean;
  onLocked?: () => void;
};

/** A color of the theme: its label over it, opening the color picker. */
export const ColorField = ({ label, color, onPick, locked, onLocked }: Props) => {
  const [isPicking, setPicking] = useState(false);

  return (
    <Field $locked={locked}>
      <span className="role">{label}</span>
      <InputColor color={color} onClick={() => (locked ? onLocked?.() : setPicking(true))} active onlyPreview />
      {isPicking && (
        <SelectColorModal
          color={color}
          onExit={() => setPicking(false)}
          onSave={picked => {
            onPick(picked);
            setPicking(false);
          }}
        />
      )}
    </Field>
  );
};
